import { rem } from 'polished'
import PropTypes from 'prop-types'
import React, { useState, useRef } from 'react'
import styled from 'styled-components'
import { Flex } from 'components/Layout'
import { ReadMore } from 'components/ReadMore'
import { Text } from 'components/Typography'
import { COLOR, FONT_SIZE, FONT_STACK, SPACE } from 'Theme'

const FEEDBACK_COLLAPSED_HEIGHT = rem(80)

const StyledText = styled(Text)`
  cursor: pointer;
`

export const Review = ({ feedback, name }) => {
  const readMoreWrapperRef = useRef(null)
  const [isExpanded, setIsExpanded] = useState(false)
  return (
    <Flex flexDirection="column" mt={SPACE.PX_60}>
      <Text mb={SPACE.PX_15}>{name}</Text>
      <ReadMore
        collapsedHeight={FEEDBACK_COLLAPSED_HEIGHT}
        wrapperRef={readMoreWrapperRef}
        fontFamily={FONT_STACK.SERIF}
        fontSize={FONT_SIZE.PX_16}
        isExpanded={isExpanded}
        actionButton={() => (
          <StyledText
            color={COLOR.BLACK}
            onClick={() => {
              setIsExpanded((prevState) => !prevState)
            }}
          >
            {isExpanded ? 'Show less' : 'Read more'}
          </StyledText>
        )}
      >
        <Flex flexDirection="column">
          <Text fontFamily={FONT_STACK.SERIF} color={COLOR.BLACK}>
            {feedback}
          </Text>
        </Flex>
      </ReadMore>
    </Flex>
  )
}

Review.propTypes = {
  feedback: PropTypes.string,
  name: PropTypes.number,
}
